export const kolData = {
	REQUEST: 'KOL_REQUEST',
	RECEIVE: 'KOL_RECEIVE',
};



// WEBPACK FOOTER //
// ./src/constants/widgetKol.constants.js